/**
 * vue项目对axios的全局配置
 */
import axios from 'axios'
import api from "../api";

import common from '@/common/common'
import router from "../router";
// axios默认配置
axios.defaults.timeout = 10000; // 超时时间
//axios.defaults.baseURL = 'http://localhost:8888'; // 默认地址
 axios.defaults.baseURL = common.SystemConfig.BaseUrl
// 只适用于 POST,PUT,PATCH，transformRequest` 允许在向服务器发送前，修改请求数据
// axios.defaults.transformRequest = function(data) {
//   //data = qs.stringify(data);
//   return data;
// };
// 请求拦截器
axios.interceptors.request.use(function(config) {
  if(window.vm.$store.getters.getLoginInfo.access_token){
    // fix: 🐛后端必须要首字母大写的 Bearer
    config.headers['Authorization']='Bearer '+window.vm.$store.getters.getLoginInfo.access_token
    config.headers['Content-Type']=(config, 'headers.Content-Type', 'application/json')
  }

  return config;
}, function(error) {
  return Promise.reject(error);
});

//token错误请求存储桶
let accessTokenErrorRequests=[]

//保存token错误请求
function addAccessTokenErrorRequests (callback) {
  accessTokenErrorRequests.push(callback)
}

function onAccessTokenRefreshed (newToken) {
  accessTokenErrorRequests.forEach((callback) => {
    callback(newToken)
  })
  // 清空缓存接口
  accessTokenErrorRequests = []
}

// 响应拦截器
axios.interceptors.response.use(response=> {
    let access_token=response.data.data?response.data.data.access_token:undefined
    let refresh_token=response.data.data?response.data.data.refresh_token:undefined
    let uuid=response.data.data?response.data.data.uuid:undefined
    if(access_token){
      window.vm.$store.dispatch('saveLoginInfo',{access_token:access_token,uuid:uuid,refresh_token:refresh_token});
    }
  return response.data;
}, function(error) {
  let code=error.response.status
  if(code==401){
      //token失效
      if(error.response.data.code==20401){
        console.log('token失效')
        let refresh=window.vm.$store.getters.getRefresh
        if(!refresh.isRefresh){
          window.vm.$store.dispatch('setRefresh',{  isRefresh:true,lastConfig:error.response.config});
          api.commonApi.commonIndex.refresh({
            refresh_token:window.vm.$store.getters.getLoginInfo.refresh_token
          }).then(res=>{
            window.vm.$store.dispatch('setRefresh',{  isRefresh:false,lastConfig:undefined});
            onAccessTokenRefreshed(res.data.access_token)
          },error=>{
            //刷新失败
            router.replace("/")
          })
        }
        const accessTokenErrorRequests=new Promise((resolve) => {
          // 返回Promise并且让其状态一直为等待状态,
          // 只有当token刷新成功后, 就会调用通过addSubscriber函数添加的缓存接口,
          // 此时, Promise的状态就会变成resolve
          addAccessTokenErrorRequests((newToken) => {
            // 表示用新的token去替换掉原来的token
            error.response.config.headers.Authorization = 'Bearer ' + newToken
            // 替换掉url -- 因为baseURL会扩展请求url
            error.response.config.url = error.response.config.url.replace(error.response.config.baseURL, '')
            // 用重新封装的config去请求, 就会将重新请求后的返回
            resolve(axios(error.response.config))
          })
        })
        return accessTokenErrorRequests
      }
  }
  return Promise.reject(error);
});
export default axios;



// WEBPACK FOOTER //
// ./src/http/index.js